import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=27baa82a&scoped=true&"
import script from "./SubmitButton.vue?vue&type=script&lang=js&"
export * from "./SubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27baa82a",
  null
  
)

export default component.exports